/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMemoRequestDto } from '../../models/create-memo-request-dto';
import { UserVerificationMemoDto } from '../../models/user-verification-memo-dto';

export interface CreateVerificationMemo$Params {
  id: number;
  'X-API-Version'?: string;
      body?: CreateMemoRequestDto
}

export function createVerificationMemo(http: HttpClient, rootUrl: string, params: CreateVerificationMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<UserVerificationMemoDto>> {
  const rb = new RequestBuilder(rootUrl, createVerificationMemo.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserVerificationMemoDto>;
    })
  );
}

createVerificationMemo.PATH = '/api/user-verifications/{id}/memos';
